import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { useLanguage } from '../context/LanguageContext';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowLeft } = FiIcons;

export default function PrivacyPolicy() {
  const { t } = useLanguage();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <motion.div 
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen bg-brand-black pt-32 pb-20 px-6"
    >
      <div className="max-w-3xl mx-auto">
        <Link 
          to="/" 
          className="inline-flex items-center gap-2 text-brand-gold/60 hover:text-brand-gold text-xs tracking-widest uppercase mb-12 transition-colors group"
        >
          <SafeIcon icon={FiArrowLeft} className="group-hover:-translate-x-1 transition-transform" />
          {t.backHome}
        </Link>

        <header className="mb-16">
          <h1 className="font-serif text-4xl md:text-5xl text-white mb-4 tracking-wide">
            {t.privacy.title}
          </h1>
          <p className="text-brand-gold/50 font-sans text-xs tracking-widest uppercase">
            {t.privacy.effectiveDate}
          </p>
        </header>

        <div className="space-y-12 text-white/70 font-sans leading-relaxed text-sm md:text-base">
          <p className="text-white/90 text-lg font-light leading-relaxed">
            {t.privacy.intro}
          </p>

          <div className="space-y-10">
            {t.privacy.sections.map((section, index) => (
              <section key={index} className="space-y-4">
                <h2 className="font-serif text-xl text-brand-gold/90 tracking-wide">
                  {section.title}
                </h2>
                <div className="h-[1px] w-8 bg-brand-gold/20 mb-4"></div>
                <p>{section.content}</p>
              </section>
            ))}
          </div>

          <section className="pt-8 border-t border-white/5">
            <p className="font-medium text-white italic">
              {t.privacy.contact}
            </p>
          </section>
        </div>

        <div className="mt-20 pt-10 border-t border-white/5">
          <p className="font-serif text-xl tracking-ultra-wide text-brand-gold/40">
            METANOIA
          </p>
        </div>
      </div>
    </motion.div>
  );
}